import React from 'react'
import SearchPopup from './SearchPopup'
import { Modal, ModalBody, ModalContent } from '@nextui-org/react'

function PopupWrapperSearch({
    asset,
    searchType,
    setSearchType,
    includeTubes = false,
    includeDrops = false,
}) {
    const onClose = () => {
        setSearchType(null)
    }

    return (
        <Modal
            isDismissable={false}
            size={'full'}
            isOpen={searchType}
            onClose={onClose}
            scrollBehavior="inside"
            classNames={{
                wrapper: 'z-[1312]',
                body: 'p-0',
                closeButton:
                    'absolute top-2 right-2 z-50 bg-red-500 text-white hover:bg-red-600',
            }}
        >
            <ModalContent>
                <ModalBody className="px-0">
                    <SearchPopup
                        asset={asset}
                        searchType={searchType}
                        callBack={onClose}
                        includeTubes={includeTubes}
                        includeDrops={includeDrops}
                    />
                </ModalBody>
            </ModalContent>
        </Modal>
    )
}

export default PopupWrapperSearch
